import { render, staticRenderFns } from "./RouletteResult.vue?vue&type=template&id=d55d6848&scoped=true"
import script from "./RouletteResult.vue?vue&type=script&lang=js"
export * from "./RouletteResult.vue?vue&type=script&lang=js"
import style0 from "./RouletteResult.vue?vue&type=style&index=0&id=d55d6848&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d55d6848",
  null
  
)

export default component.exports